export default "__VITE_ASSET__38b6f942__"